import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_courtOrderList = _resolveComponent("courtOrderList")!
  const _component_KTModalCard = _resolveComponent("KTModalCard")!
  const _component_modal_filiation = _resolveComponent("modal-filiation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_courtOrderList, {
      title: "Filiación nueva persona privada de libertad",
      description: "Presiona <strong>Iniciar registro</strong> para realizar la filiación de una nueva persona privada de libertad. <br /> \r\n    Presiona <strong>Lista Privados de Libertad</strong> para ver la lista de personas privadas de libertad registradas.",
      "button-text": "Iniciar Registro",
      "modal-id": "kt_modal_filiation"
    }),
    _createVNode(_component_KTModalCard, {
      title: "Filiación nueva persona privada de libertad",
      description: "Presiona <strong>Iniciar registro</strong> para realizar la filiación de una nueva persona privada de libertad. <br /> \r\n    Presiona <strong>Lista Privados de Libertad</strong> para ver la lista de personas privadas de libertad registradas.",
      "button-text": "Iniciar Registro",
      "modal-id": "kt_modal_filiation"
    }),
    _createVNode(_component_modal_filiation)
  ], 64))
}